import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-legends',
    templateUrl: './legends.component.html',
    styleUrls: ['./legends.component.scss'],
    standalone: false // NOSONAR
})
export class LegendsComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<LegendsComponent>) { }

  ngOnInit(): void {
    console.info('something')
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
